var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReadFile',{attrs:{"accept":"image/*","multiple":false,"disabled":!_vm.canLoad,"value":_vm.loading},on:{"change":_vm.load}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }